export function initSelectionHandler() {
    $('input.select-all').click(function () {
      var checked = this.checked;
      $('input.select-item').each(function (index, item) {
        item.checked = checked;
      });
    });
  
    $('input.select-item').click(function () {
      checkSelected();
    });
  
    function checkSelected() {
      var all = $('input.select-all')[0];
      var total = $('input.select-item').length;
      var len = $('input.select-item:checked').length;
      all.checked = len === total;
    }
  
    $('#bsubmit').click(function () {
      $('#bcount').text($('input.select-item:checked').length);
    });
  
    $('#bmsubmit').click(function () {
      $('#bform').submit();
    });
  }